import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { Grid } from '@grnhse/seedling/lib/birch/layouts/grid';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import { withLocalePrefix } from 'shared/utils/translation';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import Api from '../lib/api';
import SchoolsDropdown from '../components/dropdowns/schools';
import DegreesDropdown from '../components/dropdowns/degrees';
import DisciplinesDropdown from '../components/dropdowns/disciplines';
import { ButtonWrapper } from './index';

const t = withLocalePrefix('talent_search.form.sections');

type Props = {
  apiClient: Api;
};

const Education = ({ apiClient }: Props) => {
  const { watch, setValue } = useFormContext();
  const [schools, degrees, disciplines, showEducation] = watch([
    'schools',
    'degrees',
    'disciplines',
    'show_education',
  ]);

  if (
    !showEducation &&
    (schools.length || degrees.length || disciplines.length)
  ) {
    setValue('show_education', true);
  }

  const removeEducationFields = () => {
    setValue('schools', []);
    setValue('degrees', []);
    setValue('disciplines', []);
    setValue('show_education', false);
  };

  if (!showEducation) {
    return (
      <ButtonWrapper>
        <TertiaryButton
          data-provides={'show-education-fields-button'}
          onClick={() => setValue('show_education', true)}
        >
          {t('candidate.labels.add_education_filters')}
        </TertiaryButton>
      </ButtonWrapper>
    );
  }

  return (
    <Stack spacing={2}>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <SchoolsDropdown
            apiClient={apiClient}
            testId="talent-search-school-name-dropdown"
            label={t('candidate.labels.school_name')}
          />
        </Grid>
        <Grid item xs={12}>
          <DegreesDropdown
            apiClient={apiClient}
            testId="talent-search-degree-dropdown"
            label={t('candidate.labels.degree')}
          />
        </Grid>
        <Grid item xs={12}>
          <DisciplinesDropdown
            apiClient={apiClient}
            testId="talent-search-discipline-dropdown"
            label={t('candidate.labels.discipline')}
          />
        </Grid>
      </Grid>
      <ButtonWrapper>
        <TertiaryButton
          data-provides={'remove-education-fields-button'}
          onClick={removeEducationFields}
        >
          {t('candidate.labels.remove_education_filters')}
        </TertiaryButton>
      </ButtonWrapper>
    </Stack>
  );
};

export default Education;
